import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';
import { AktiveFilterService } from '../filter/aktive-filter.service';
import { CombinedFacettenUrlService } from './combined-facetten-url.services';
import { OrtFacettenService } from './instance/ort-facetten.service';

@Injectable({
  providedIn: 'root'
})
export class FacettenResetService {
  private readonly aktiveFilterService = inject(AktiveFilterService);
  private readonly combinedFacettenUrlService = inject(CombinedFacettenUrlService);
  private readonly ortFacettenService = inject(OrtFacettenService);

  public showZuruecksetzen$ = this.aktiveFilterService.anzahlAktiveFilter$.pipe(
    map((anzahl) => anzahl > 0)
  );

  public async resetFilter(): Promise<void> {
    await this.combinedFacettenUrlService.resetOptionSelections();
    this.ortFacettenService.reset();
  }
}
